export enum KnmNotificationTypeEnum {
  EPGU = 'EPGU',
}
